import ThemeChoose from "./classes/ThemeChoose";
// Dom Elements Declarations
window.addEventListener('load', () => {
	let theme = new ThemeChoose("#theme-choose");

	let hamburger = document.querySelector(".hamburger");
	hamburger.addEventListener("click", () => {
		hamburger.classList.toggle("active");
		document.querySelector(".header_nav").classList.toggle("active");
	});

	let header = document.querySelector('header');
	// Header sticky
	window.addEventListener("scroll", function () {
		if (window.scrollY > 0) {
			document.querySelector(".header_nav").classList.add("sticky");
		}
		else {
			document.querySelector(".header_nav").classList.remove("sticky");
		}
	});
})



// WEBPACK FOOTER //
// ./src/ts/main.ts